const localeFormat = (localeString) => {
  const [language, country] = localeString.split('-');
  return `${language.toLowerCase()}-${country}`;
};

export default localeFormat;
